import React from 'react';
import Icon from '../../../components/AppIcon';

const ProjectGoals = () => {
  const goals = [
    {
      id: 1,
      icon: 'Target',
      title: 'Heritage Preservation',
      description: 'Safeguard cultural and natural heritage sites through digital documentation and sustainable tourism practices that respect local traditions and environments.'
    },
    {
      id: 2,
      icon: 'Users',
      title: 'Community Empowerment',
      description: 'Support local communities by creating economic opportunities through tourism while maintaining authentic cultural practices and traditional craftsmanship.'
    },
    {
      id: 3,
      icon: 'Globe',
      title: 'Cross-Border Cooperation',
      description: 'Foster regional collaboration between Serbia and Montenegro to develop unified tourism strategies and shared heritage promotion initiatives.'
    },
    {
      id: 4,
      icon: 'Leaf',
      title: 'Sustainable Development',
      description: 'Promote responsible tourism that minimizes environmental impact while maximizing benefits for local economies and cultural preservation.'
    },
    {
      id: 5,
      icon: 'BookOpen',
      title: 'Cultural Education',
      description: 'Educate visitors about regional history, traditions, and natural heritage through immersive storytelling and interactive experiences.'
    },
    {
      id: 6,
      icon: 'Smartphone',
      title: 'Digital Innovation',
      description: 'Leverage modern technology to create accessible, engaging platforms that connect travelers with authentic local experiences and heritage sites.'
    }
  ];

  return (
    <div className="bg-card rounded-lg shadow-card p-8 mb-8">
      <div className="text-center mb-8">
        <h2 className="font-heading font-semibold text-2xl text-foreground mb-3">
          Project Goals & Objectives
        </h2>
        <p className="text-muted-foreground max-w-2xl mx-auto">
          Our comprehensive approach to heritage tourism development focuses on sustainable practices, 
          community involvement, and innovative digital solutions.
        </p>
      </div>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {goals?.map((goal) => (
          <div key={goal?.id} className="group">
            <div className="bg-surface rounded-lg p-6 h-full transition-all duration-fast card-hover">
              <div className="flex items-start gap-4">
                <div className="flex-shrink-0">
                  <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center group-hover:bg-primary/20 transition-colors duration-fast">
                    <Icon name={goal?.icon} size={20} className="text-primary" />
                  </div>
                </div>
                <div className="flex-1">
                  <h3 className="font-heading font-semibold text-base text-foreground mb-2">
                    {goal?.title}
                  </h3>
                  <p className="text-sm text-muted-foreground leading-relaxed">
                    {goal?.description}
                  </p>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProjectGoals;